import { memo } from "react";

import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion/accordion";

import { CheckboxList } from "./CheckboxList";

import type { InSaleAndStopSellingItemsType } from "../../../type";
import type { CheckedState } from "@radix-ui/react-checkbox";

type FilterAccordionItemProps = {
	uniqueId: string;
	label: string;
	items: InSaleAndStopSellingItemsType;
	selectedItemIDs: string[];
	isPending: boolean;
	onCheckedChange: (params: { checked: CheckedState; id: string }) => void;
};

export const FilterAccordionItem = memo(
	({ uniqueId, label, items, selectedItemIDs, isPending, onCheckedChange }: FilterAccordionItemProps) => {
		return (
			<AccordionItem value={uniqueId}>
				<AccordionTrigger>
					<p className="text-sm">{label}</p>
				</AccordionTrigger>
				<AccordionContent>
					<CheckboxList
						items={items}
						selectedItemIDs={selectedItemIDs}
						isPending={isPending}
						onCheckedChange={onCheckedChange}
					/>
				</AccordionContent>
			</AccordionItem>
		);
	},
);

FilterAccordionItem.displayName = "FilterAccordionItem";
